import {Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit} from '@angular/core';
import {
  EnumContractDetailType,
  EnumContractEnterpriseStatus,
  EnumContractStatus,
  EnumContractUserRole, EnumContractUserStatus
} from "src/app/core/constants/contract";
import {AutoUserService} from "../../../../../../core/services/auto-user.service";
import {ToastrService} from "ngx-toastr";
import {CommonService} from "../../../../../../core/services/common.service";
import {Message} from "../../../../../../core/class/message";
import {ViewDocumentReferenceComponent} from "../../../../../../shared/components/view-document-reference/view-document-reference.component";
import {MatDialog} from "@angular/material/dialog";
import {FileAttachComponent} from "../../../../../../shared/components/file-attach/file-attach.component";
import {BaseComponent} from "../../../../../../shared/components/base/base.component";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {DocumentService} from "../../../../../../core/services/document.service";
import {ContractService} from "../../../../../../core/services/contract.service";
import {ActivatedRoute} from "@angular/router";

// Jquery function for enabling radio and checkbox
declare function enableFormFields(): any;

// Jquery function for enabling input
declare function enableFormInput(): any;

@Component({
  selector: 'app-panel-setup-sign-flow-receive',
  templateUrl: './panel-setup-sign-flow-receive.component.html',
  styleUrls: ['./panel-setup-sign-flow-receive.component.scss']
})
export class PanelSetupSignFlowReceiveComponent extends BaseComponent implements OnInit, AfterViewInit {
  customer: any;
  enterpriseId: string;
  public listEnterpriseSign: any;
  private listOfDataUserSign: any;
  private id: string;

  constructor(
    public autoUserService: AutoUserService,
    private toastr: ToastrService,
    public commonService: CommonService,
    public message: Message,
    private dialog: MatDialog,
    private documentService: DocumentService,
    private contractService: ContractService,
    private route: ActivatedRoute,
  ) {
    super(commonService, message);
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.id = this.route.snapshot.paramMap.get('id');
  }

  documentReference = [{
    id: '',
    name: '',
    code: ''
  }];
  //enum
  enumContractStatus = EnumContractStatus;
  roleUser = EnumContractUserRole;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  isValidExistingSigning = false;
  isValidEnterpriseForm = false;
  isValidNoUserExist = false;
  valueSelectedUserRole: string = (this.roleUser.APPROVE + "");

  @Output() navigate: any = new EventEmitter<boolean>();
  @Input() documentInfo: any;
  inputUserValue: string;
  filteredUserOptions = [];
  RECORD_USER_PERFORM_SIGN = [];
  RECORD_SUBJECT_SIGN = [];
  enumContractDetailType = EnumContractDetailType;
  enumContractUserStatus = EnumContractUserStatus;
  enumContractUserRole = EnumContractUserRole;
  selectedDocumentType: { id: string, name: '', parentId: null };
  selectedDocumentTypeParent: { id: string, name: string, code?: string };
  valueSelect = null;
  serviceTypes = [];

  checkFocus = false;
  dialogRefFileAttachComponent: any;
  attachments = [];
  listOfMapData = [];
  dataSourceUser = new MatTableDataSource();
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  mapOfExpandedData: { [key: string]: any } = {};
  document = {
    id: '',
    code: '',
    name: '',
    parentId: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    documentTypeEnterpriseId: '',
    customerId: '',
    status: 0,
    filePath: '',
    description: '',
    assignUserId: 0,
    typeId: null,
    isDeleted: true,
    jsonData: '',
    email: '',
    phone: '',
    createdBy: '',
    createdTime: '',
    updatedBy: '',
    updatedTime: '',
    finishDate: '',
    salt: '',
    documentTypeContent: '',
    expiredDate: '',
    contractAttachments: [],
    newUploadContractAttachments: [],
    isSended: false,
    serviceType: null,
    isDifferentEnterprise: false,
  };

  ngOnInit() {
    this.dataSourceUser.sort = this.sort;
    this.getListEnterpriseUserSignByDocumentId()
  }

  ngAfterViewInit() {
    if (this.documentInfo) {
      this.document = this.documentInfo;
    }
  }


  collapse(array, data, $event: boolean): void {
    if ($event === false) {
      if (data.children) {
        data.children.forEach(d => {
          const target = array.find(a => a.key === d.key)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }

  public viewDocumentReference(id) {
    if (this.selectedDocumentTypeParent && this.selectedDocumentTypeParent.id) {
      const dialogRef = this.dialog.open(ViewDocumentReferenceComponent, {
        width: '90%',
        minHeight: '90%',
        data: this.selectedDocumentTypeParent.id,
      });
      dialogRef.afterClosed().subscribe(rs => {
        enableFormFields();
        enableFormInput();
        // document.getElementById('focusSelect').focus();
      });
    } else {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.not_documentId'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.not_documentId'));
      }
    }
  }

  onChangeUserSignSearch(event): void {
    this.isLoadUserSign = true;
    this.autoUserService.fetchAuto(event)
      .then(result => {
        //console.log(result);
        this.filteredUserOptions = result;
      }).finally(() => {
      this.isLoadUserSign = false;
    })
  }

  isFormChanging = false;
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  isLoadUserSign = false;

  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  public onAddAttachFile() {
    const arrAttachBindToDialog = [];
    this.document.newUploadContractAttachments.forEach(element => {
      arrAttachBindToDialog.push(element);
    });

    this.dialogRefFileAttachComponent = this.dialog.open(FileAttachComponent, {
      width: '40%',
      data: {
        attachments: this.attachments,
        customerName: this.customer.customerName,
        newUploadContractAttachments: arrAttachBindToDialog
      }
    });

    this.dialogRefFileAttachComponent.afterClosed().subscribe(rs => {
      if (rs) {
        this.setFormChanging(true);
        this.document.contractAttachments = this.dialogRefFileAttachComponent.componentInstance.onAttachFile();
        this.document.newUploadContractAttachments
          = this.dialogRefFileAttachComponent.componentInstance.uploadMultiFileComponent.arrAttachments;
      } else {
        this.attachments = this.dialogRefFileAttachComponent.componentInstance.rollBackAttach();
      }
      // document.getElementById('focusSelect').focus();
    });
  }

  checkExistedUser(id: string, fullname: string, email: string) {
    const existedList = this.RECORD_USER_PERFORM_SIGN.filter((e) => {
      return e.userId == id
    });

    if (existedList.length > 0) {
      this.toastr.warning(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate'), [fullname + " - " + email]));
      return true;
    } else {
      return false;
    }
  }

  autocompleteUserSelected($event: any, model: any) {
    // console.log(this.inputUserValue)
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if (!this.checkExistedUser(model.id, model.fullName, model.email)) {
        this.RECORD_USER_PERFORM_SIGN = [
          ...this.RECORD_USER_PERFORM_SIGN,
          {
            order: this.RECORD_USER_PERFORM_SIGN.length,
            userId: model.id,
            enterpriseId: model.enterpriseId,
            userName: model.fullName,
            userEmail: model.email,
            userRole: this.valueSelectedUserRole,
            userPhone: model.phone,
            enterpriseEmail: null,
            enterpriseName: null,
            taxCode: model.taxCode
          }
        ];
        this.inputUserValue = "";
        this.valueSelectedUserRole = (this.roleUser.APPROVE + '');
      }
    }
  }

  downloadFile(id, name) {
    this.commonService.downloadDocumentFile(id).subscribe(rs => {
      this.downLoadFile(rs, 'application/octet-stream', name);
    });
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  onClickDeleteElementRecordUser(userId: any): void {
    this.RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN.filter(d => d.userId !== userId);
    this.setFormChanging(true);
  }

  getListEnterpriseUserSignByDocumentId() {
    if(this.id){
          this.documentService.getListEnterpriseUserSignBydocumentIdService(this.id).subscribe(rs => {
      if (rs.data) {
        let {enterpriseSign, userSign} = rs.data;
        this.listEnterpriseSign = enterpriseSign;
        this.listOfDataUserSign = userSign;
      }
    }, (error) => console.log(error));
    }
  }

  onSaveSignFlow() {
    if (!this.validateErrorSetUser(null)) {
      const data = {
        ...this.document,
        userSign: this.RECORD_USER_PERFORM_SIGN
      }
      this.contractService.updateUserSignReceive(data)
        .subscribe(result => {
          console.log(result);
        });
    }
  }

  //validate form User
  private validateErrorSetUser(model?) {
    //Kiểm tra trong list ko chua User nào?
    if (this.listOfDataUserSign.filter(x => x.order !== 0).length == 0 || this.listOfDataUserSign.filter(x => x.order !== 0).length == null) {
      this.isValidNoUserExist = true;
      return true;
    } else {
      this.isValidNoUserExist = false;
    }
    //Kiểm tra chỉ 1 người ký + đó là người cuối cùng hay không?
    const temp = this.RECORD_USER_PERFORM_SIGN.filter((e) => {
      return e.userRole == this.roleUser.SIGN.toString();
    });

    if (temp.length > 1 || this.RECORD_USER_PERFORM_SIGN[this.RECORD_USER_PERFORM_SIGN.length - 1].userRole != this.roleUser.SIGN.toString()) {
      this.isValidExistingSigning = true;
      return true;
    } else {
      this.isValidExistingSigning = false;
    }
    return false;
  }
}
